import { useEffect, useRef } from "react";
import { SIDEBAR_ID } from "../../../shared/constants";

export const useScrollSidebar = ({
  id,
  isActive,
}: {
  id: string;
  isActive: boolean;
}) => {
  const scrollRef = useRef<HTMLElement | null>(null);
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isActive) return;

    if (!containerRef.current) {
      containerRef.current = document.getElementById(SIDEBAR_ID);
      if (!containerRef.current) return;
    }

    // Cache the scroll element reference
    if (!scrollRef.current) {
      scrollRef.current = containerRef.current.querySelector(
        "[data-radix-scroll-area-viewport]",
      ) as HTMLElement;
    }

    const scroll = scrollRef.current;
    const category = containerRef.current.querySelector(
      `[data-sidebar-id="${id}"]`,
    ) as HTMLElement;

    if (!scroll || !category) return;

    const scrollRect = scroll.getBoundingClientRect();
    const categoryRect = category.getBoundingClientRect();

    // Calculate if element is out of view
    const isAbove = categoryRect.top < scrollRect.top;
    const isBelow = categoryRect.bottom > scrollRect.bottom;

    if (!isAbove && !isBelow) return; // Already in view

    // Scroll into view with appropriate offset
    const scrollTop = isAbove
      ? scroll.scrollTop + (categoryRect.top - scrollRect.top) - 8
      : scroll.scrollTop + (categoryRect.bottom - scrollRect.bottom) + 8;

    scroll.scrollTo({
      top: scrollTop,
      behavior: "smooth",
    });
  }, [id, isActive]);
};
